import { render, staticRenderFns } from "./SignUserMessage.vue?vue&type=template&id=e9e120a0&scoped=true&"
import script from "./SignUserMessage.vue?vue&type=script&lang=js&"
export * from "./SignUserMessage.vue?vue&type=script&lang=js&"
import style0 from "./SignUserMessage.vue?vue&type=style&index=0&id=e9e120a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e120a0",
  null
  
)

export default component.exports